import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  ToolbarModule,
  TabsModule,
  PaginationModule,
  SettingsModule,
  TableModule,
} from 'beyond-util';
import { VideoUputstvaComponent } from './video-uputstva.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    PaginationModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    NgxSpinnerModule,
  ],
  declarations: [VideoUputstvaComponent],
  entryComponents: [VideoUputstvaComponent],
  exports: [VideoUputstvaComponent],
  providers: [],
})
export class VideoUputstvaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/video-uputstva/video-uputstva.module.ts